import React, { Component, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import Dropdown from 'rsuite/Dropdown';
import 'rsuite/dist/rsuite.min.css';
import { useCookies } from 'react-cookie';
import i18n from "i18next";
import getList from "../Redux/actions/CommonServices";
import { getTranslationSuccess } from '../Redux/actions/translationActions';
import { useDispatch, useSelector } from 'react-redux';
import { transLabel } from '../translations/util';
import { useSearchParams } from 'react-router-dom';

const Header = () => {
    const [cookies, setCookie] = useCookies(['languaje']);
    const forceUpdate = React.useReducer(bool => !bool)[1];
    const translations = useSelector(state => state.translationReducer);
    const [searchParams, setSearchParams] = useSearchParams();

    const dispatch = useDispatch();

    useEffect(() => {
        let lan = (cookies.languaje == null) ? "ES" : cookies.languaje;
        getList("Translations/Get", null, function (response) {

            let pLan = searchParams.get("lan");
            if (pLan != null) {
                if (response.filter(c => c.lan == pLan).length > 0) {
                    setCookie('languaje', pLan, { path: '/', sameSite: 'lax' });
                    lan = pLan;
                }
            }

            if (cookies.languaje == null) {
                setCookie('languaje', "ES", { path: '/', sameSite: 'lax' });
            }
            let filterTranslations = response.filter(c => c.lan == lan);
            //setTranslations(filterTranslations);
            dispatch(getTranslationSuccess(filterTranslations));
        });
    }, []);

    const onSelectLanguaje = (newName) => {
        setCookie('languaje', newName, { path: '/', sameSite: 'lax' });
        getList("Translations/Get", null, function (response) {
            let filterTranslations = response.filter(c => c.lan == newName);
            //setTranslations(filterTranslations);
            dispatch(getTranslationSuccess(filterTranslations));
        });
    }

    /*useEffect(()=>{
        let lan = cookies.languaje;
        if (lan == null){
            lan = "ES";
        }
        i18n.changeLanguage(cookies.languaje);
    },[])*/

    const { t } = useTranslation();
    return (
        <>
            <header id="header">
                <div id="div-header" className="container-fluid ">
                    <div className="row">
                        <div className="col-md-6 d-flex">
                            <div className="d-flex justify-content-start" style={{ borderRight: "1px solid white", paddingRight: "25px", maxHeight: "40px", alignSelf: "center" }}>
                                <img src="assets/img/logo-ayesa-mini-2024.png" width="120" />
                            </div>
                            <div>
                                <p className="text-light" style={{ fontSize: "20px", marginLeft: "20px", marginTop: "2px" }}>{transLabel("header.title")}</p>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex justify-content-start justify-content-md-end flex-wrap align-content-center">
                            {/*<p href="#about" className="text-light">ES <a href="#" style={{fontFamily: "Material Icons", color:"white", textDecoration: "none"}}>arrow_drop_down</a></p>*/}
                            <Dropdown onSelect={onSelectLanguaje} title={cookies.languaje} toggleClassName="dropTranslation">
                                <Dropdown.Item eventKey="ES">ES</Dropdown.Item>
                                <Dropdown.Item eventKey="EN">EN</Dropdown.Item>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;
